<template>
	<div>
		<button type="button" class="button medium-button d-flex justify-content-between" @click="openModal()" id="new-provider-button" style="min-width:150px;">
			<slot name="text-button"></slot>
		</button>

		<b-modal v-model="show_add_provider" no-close-on-backdrop title="Add employee" ok-title="Cancel" ok-only ok-variant="secondary" @hidden="resetModal" @cancel="resetModal" size="xl">
			<div class="mb-2">
				
				<div class="form-group input-content">
					<template v-if="!checked">
						<div class="row">
							<div class="col">
								<p>Insert the <span class="underline">country code and the cell phone number</span> to add an employee.</p>

								<template v-if="course != null">
									<p>
										<strong>Program:</strong> {{ course.name }}.
									</p>
								</template>
							</div>
						</div>
						<div class="row">

							<div class="col-3">
								<phone-country-code
								:rule="'required'"
								:section="'new-provider'"
								:country_codes="country_codes"
								:form="form"
								@countryInputNewProvider="countryInput"/>
					
							</div>
							<div class="col-9">
								<label>Cell phone number</label>
								<input placeholder="Cell phone number" type="text" v-model="phone_validator" class="form-control" name="phone"
									v-validate="'required|min:8|max:10'" @keyup.enter="checkIfExists" style="height: 31px;">
								<span  class="input-error-msg">{{ errors.first('phone') }}</span>
							</div>
						</div>

						<div class="row mt-4" >
							<div class="col">
								<div class="text-right ">
									<button type="button" class="button medium-button" 
									 :class="{ 'input-disabled' : !valid_phone || form.country_code == null }"
									:disabled="!valid_phone || form.country_code == null"
									@click="checkIfExists">Next</button>
								</div>
							</div>
						</div>
					</template>
					<div v-else class="mt-2">

						<template v-if="exists">

							<div class="text-center">

								<div v-if="status == 'EXISTS_BUT_NOT_ASIGNED'">
									<div>This employee is <span class="underline">not in the system</span>.</div>
								</div>

								<div v-if="status == 'SUSPENDED'">This employee is currently <span class="underline">deactivated</span> in your agency.</div>

								<div v-if="status == 'ACTIVE'">This employee <span class="underline">was found in the system</span>.</div>

								<template v-if="course != null">
									<div v-if="status_course == 'NOT_IN_COURSE'">
										This employee is <span class="underline">not active</span> in the program <span class="underline">{{ course.name }}</span>.
									</div>
									<div v-if="status_course == 'SUSPENDED_IN_COURSE'">
										This employee is  <span class="underline">deactivated</span> in the program <span class="underline">{{ course.name }}</span>.
									</div>
									<div v-if="status_course == 'ACTIVE_IN_COURSE'">
										This employee is <span class="underline">active</span> in the program <span class="underline">{{ course.name }}</span>.
									</div>
								</template>

								<template v-if="provider != null">
									<div class="mt-2"><strong>First name:</strong> {{ provider.first_name }}</div>
									<div><strong>Last name:</strong> {{ provider.last_name }}</div>
									<div><strong>Cell phone number:</strong> {{ form.country_code.value }} {{ form.phone }}</div>
								</template>

								<div class="mt-3">
									<button type="button" class="btn btn-secondary" @click="resetModal">Try another cell phone number</button>

									<template v-if="course == null">
										<!-- actions for adding to a organization -->
										<template v-if="status == 'EXISTS_BUT_NOT_ASIGNED'">
											<button type="button" class="button" @click="addProvider">Add employee and go to profile</button>
										</template>

										<template v-if="status == 'SUSPENDED'">
											<button type="button" class="button" @click="addProvider">Activate employee and go to profile</button>
										</template>
										
										<template v-if="status == 'ACTIVE'">
											<router-link v-if="user_role === 'csm' " :to="{ name: this.user_role+'.providers.detail', params : { id : provider.id }, query : {agency_id : this.agency_id}}" target="_blank" tag="a" class="button">
												Go to profile
											</router-link v-if="provider != null">
											<router-link v-if="user_role != 'csm'" :to="{ name: this.user_role+'.providers.detail', params : { id : provider.id }}" target="_blank" tag="a" class="button">
												Go to profile
											</router-link v-if="provider != null">
										</template>
									</template>
									<template v-else>
										<!-- actions when adding a course -->

										<template v-if="status_course == 'NOT_IN_COURSE'">
											<button type="button" class="button" @click="activateProviderAndAddToCourse">Add employee to program</button>
										</template>

										<template v-if="status_course == 'SUSPENDED_IN_COURSE'">
											<button type="button" class="button" @click="activateProviderAndAddToCourse">Activate employee in program</button>
										</template>

										<template v-if="status_course == 'ACTIVE_IN_COURSE' && (status == 'SUSPENDED' || status == 'EXISTS_BUT_NOT_ASIGNED')">
											<button type="button" class="button" @click="activateProviderAndAddToCourse">Add employee and activate in program</button>
										</template>
									</template>
								</div>
							</div>							

						</template>
						<template v-else>

							<div class="text-center mt-4">
								<div class="">The employee with the cell phone number 
									<span class="underline">{{ form.country_code.value }} {{ form.phone }} </span>
									doesn't exists.
								</div> 

								<div class="mt-3">
									<button type="button" class="btn btn-secondary" @click="resetModal">Try another cell phone number</button>

									<template v-if="course == null">
											<router-link :to="{ name: this.user_role+'.providers.create', query : { country_code  : form.country_code.value.replace('+', ''), phone : form.phone } }" tag="a" target="_blank" class="button">
											Create employee

											<template v-if="course != null"> and add to program</template>
										</router-link>
									</template>
									<template v-else>
										<button type="button" class="button" @click="createProviderAndAddToCourse">
											Create employee and add to program
										</button>
									</template>
								</div>
								
							</div>
						</template>
					</div>
				</div>
			</div>
		</b-modal>

	</div>
</template>

<script>
import PhoneCountryCode from '../shared/inputs/PhoneCountryCode'

	export default {
		components:{
			PhoneCountryCode
		},
		props : {
			course : {
				type : Object, 
				required : false
			},
			user_role:{
				type: String,
				required : false
			}
		},
		computed:{
			valid_phone: function(){
				return this.phone_validator.length > 8 && this.phone_validator.length < 11
			}
		},
		data : function(){
			return {
				agency_id:this.$route.params.agency_id,
				show_add_provider : false,
		    	country_codes : [],
				phone_validator:'',

		    	form : {
		    		country_code : {
						label : '+1',
						value : '+1'
					},
		    		phone : ''
		    	},

		    	checked : false,
		    	exists : false,
		    	status : '',
		    	status_course : '',
		    	provider : null,
				default_agency_code:''
			}
		},
		watch:{
			phone_validator: function(val){
				if(val != null){
					var removedText = val.replace(/\D+/g, '');
					this.phone_validator = removedText
					this.form.phone = removedText
				}
				
			}
		},
		mounted: function(){
		},
		created : function(){
			this.resetModal();
			this.getOrganization();
			this.getCountries();
		},
		methods : {
			openModal: function(){
				this.resetModal();
				this.show_add_provider = !this.show_add_provider

			},
			getOrganization : function(){
				if(this.agency_id == undefined){
					this.form.country_code = this.$store.getters.getCountryCode
					this.default_agency_code = this.$store.getters.getCountryCode
					return
				}
					var params = {
						id : this.agency_id
					}
					this.$store.dispatch('getOrganization', params).then((res) => {
						this.form = res.data.data;
						this.default_agency_code = res.data.data.country_code
						console.log(res)
					}).catch((error) => {
						console.log(error);
					});
					
			},
			countryInput: function(val){
				this.form.country_code = val
			},
			getCountries : function(){
				this.$store.dispatch('getCountries', {}).then((res) => {
					this.country_codes = res.data.data;
				}).catch((error) =>{	
					console.log(error);
				});
			},

			checkIfExists : function(){
				if(this.user_role === 'csm'){
					var params = {
						organization_id:this.agency_id,
						country_code : this.form.country_code.value || this.form.country_code ,
						phone : this.form.phone,
						filters : {
							page_loading : false
						}
					}
				}else{
					var params = {
						country_code : this.form.country_code.value || this.form.country_code,
						phone : this.form.phone,
						filters : {
							page_loading : false
						}
					}
				}
				this.$validator.validateAll().then((result) =>{
					if(result){
						if(this.course != null){
							params.filters.course_id = this.course.id;
						}

					this.$store.dispatch('getStatusInOrganization', params).then((response) => {

						this.status = response.data.status;
						this.status_course = response.data.status_course;
						this.provider = response.data.provider;

						if(this.status == 'NOT_EXISTS_IN_SYSTEM'){	
							

							this.show_add_provider = false;
							//if not exists, redirect and avoid popup
							if(this.course == null){
								let temp_country_code = ''
								if(typeof this.form.country_code == 'object'){
									temp_country_code = this.form.country_code.value
								}else{
			 						temp_country_code = this.form.country_code
								}
								this.$emit('updateNewProviderComponent')
								this.$router.push({ 
									name: this.user_role+'.providers.create', 
									query : { 
										country_code : temp_country_code.replace('+',''),
										phone : this.form.phone,
										agency_id : this.agency_id
									},
								});
							}else{
								this.createProviderAndAddToCourse();
							}

							this.exists = false;

						}else{

							//if exists, check if is in the agency
							if(this.status == 'EXISTS_BUT_NOT_ASIGNED'){

								this.show_add_provider = false;
								if(this.course == null){
									this.addProvider();
								}else{
									this.activateProviderAndAddToCourse();
								}

							}else{
								this.exists = true;
								this.checked = true;
							}
						}

							}).catch((error) => {
								console.log(error);
							})

					}
				})
			},
			resetModal : function(){
				this.checked = false;
				this.exists = false;
				this.form.phone = '';
				this.provider = null;
				this.$validator.reset();
				this.form.country_code = this.default_agency_code
			},

			addProvider : function(){

				if(this.user_role === 'csm'){
					console.log("From NEW PROVIDER Component");
					var params = {
						organization_id : this.agency_id,
						provider_id : this.provider.id,
						create : true,
					}
				}else{
					var params = {
						organization_id : '_',
						provider_id : this.provider.id,
						create : true,
					}
				}
		
				//add/activate and go to profile
				this.$store.dispatch('addProviderToOrganization', params).then((response) => {
					this.$emit('updateNewProviderComponent')
					if(this.user_role === 'csm'){
						this.$router.push({ name: this.user_role+'.providers.detail', params : { id : params.provider_id}, query:{agency_id : this.agency_id} });
					}else{
						this.$router.push({ name: this.user_role+'.providers.detail', params : { id : params.provider_id } });
						}
				}).catch((error) => {
					console.log(error);
				})				
			},

			createProviderAndAddToCourse :  function(){
				this.$emit('addToCourseNew', {
					country_code : this.form.country_code,
					phone : this.form.phone
				});
			},

			addToCourse : function(){

				var params = {
					id : this.course.id,
					provider_id : this.provider.id
				}

				this.$store.dispatch('addProviderToCourse', params).then((res) => {
					this.$emit('addedToCourse');
				}).catch((error) => {
					console.log(error);
				});				

				this.show_add_provider = false;
			},

			activateProviderAndAddToCourse : function(){
				var params = {
					organization_id : '_',
					provider_id : this.provider.id,
					create : true,
				}
				
				//add/activate 
				this.$store.dispatch('addProviderToOrganization', params).then((response) => {
					
					//add to course
					this.addToCourse();

				}).catch((error) => {
					console.log(error);
				})				
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/shared/NewProviderComponent.vue